import { render, staticRenderFns } from "./PainelComTabs.vue?vue&type=template&id=9cbbba62"
import script from "./PainelComTabs.vue?vue&type=script&lang=js"
export * from "./PainelComTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports